import _slicedToArray from "/builds/1-Ndk5Hm/0/webservices/sites/dental-dna-cigna-com/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { dynamicQuoteApplyURL, getReferrerKeys, updatePhoneNumber } from './campaigns';
import { cookie } from '../util/storage';
var campaignData;

var organic = function organic(cookieToCheck) {
  var referrerInfo = {
    google: ['421903', 'Google_Search'],
    bing: ['421904', 'Bing_Search'],
    yahoo: ['OSYIFP', 'Yahoo_Search'],
    cigna: ['421905', 'Other_Cigna_page'],
    default: ['421906', 'Typed_URL']
  };

  var _getReferrerKeys = getReferrerKeys(referrerInfo),
      _getReferrerKeys2 = _slicedToArray(_getReferrerKeys, 2),
      referrerCode = _getReferrerKeys2[0],
      referrerValue = _getReferrerKeys2[1];

  if (['ifpMedCampaign', 'campaignPID', 'campaignEID'].some(function (e) {
    return cookieToCheck === e;
  })) {
    cookie.set(cookieToCheck, referrerCode);
    var phoneNumber = campaignData[referrerCode] || '18002446224';

    if (cookieToCheck === 'ifpMedCampaign') {
      updatePhoneNumber(phoneNumber);
      dynamicQuoteApplyURL(referrerCode);
    }
  } else if (['campaignSource', 'campaignMedium'].some(function (e) {
    return cookieToCheck === e;
  })) {
    cookie.set(cookieToCheck, referrerValue);
  }
};

var updateCampaign = function updateCampaign(key, val) {
  if (val && val !== 'ANCORG' && val !== 'CSBORG' && val !== 'Cigna Supplemental') {
    if (key === 'ifpMedCampaign' || key === 'utm_campaign') {
      if (campaignData[val]) {
        cookie.set('ifpMedCampaign', val);
        updatePhoneNumber(campaignData[val]);
        dynamicQuoteApplyURL(val);
      } else {
        organic('ifpMedCampaign');
      }
    } else if (key === 'campaignMedium' || key === 'utm_medium') {
      cookie.set('campaignMedium', val);
    } else if (key === 'campaignSource' || key === 'utm_source') {
      cookie.set('campaignSource', val);
    } else if (key === 'campaignPID' || key === 'PID') {
      cookie.set('campaignPID', val);
    } else if (key === 'campaignEID' || key === 'EID') {
      cookie.set('campaignEID', val);
    }
  } else {
    organic(key);
  }
};

var processCampaignURL = function processCampaignURL() {
  if (location.search === '') {
    ['campaignMedium', 'campaignSource', 'campaignPID', 'campaignEID', 'ifpMedCampaign'].forEach(function (element) {
      return organic(element);
    });
  } else {
    var _location$search$spli = location.search.split('?'),
        _location$search$spli2 = _slicedToArray(_location$search$spli, 2),
        searchString = _location$search$spli2[1];

    var searchValuesObj = {};
    searchString.split('&').forEach(function (element) {
      var _element$split = element.split('='),
          _element$split2 = _slicedToArray(_element$split, 2),
          key = _element$split2[0],
          val = _element$split2[1];

      searchValuesObj[key] = val;
    });
    /* eslint-disable no-confusing-arrow */

    [{
      query: 'utm_medium',
      cookie: 'campaignMedium'
    }, {
      query: 'utm_source',
      cookie: 'campaignSource'
    }, {
      query: 'PID',
      cookie: 'campaignPID'
    }, {
      query: 'EID',
      cookie: 'campaignEID'
    }, {
      query: 'utm_campaign',
      cookie: 'ifpMedCampaign'
    }].forEach(function (element) {
      return searchValuesObj[element.query] ? updateCampaign(element.query, searchValuesObj[element.query]) : updateCampaign(element.cookie);
    });
  }
};

export default (function (jsonData) {
  campaignData = jsonData;

  if (cookie.get('ifpMedCampaign') && !location.search.includes('utm_campaign')) {
    ['campaignMedium', 'campaignSource', 'campaignPID', 'campaignEID', 'ifpMedCampaign'].forEach(function (element) {
      return updateCampaign(element, cookie.get(element));
    });
  } else {
    processCampaignURL();
  }
});